/**
 * Tope HTTP en vuelo por app (3): 6 vendedores + admin + oficina + 3 bodega en hosting ~20.
 */
const MAX_IN_FLIGHT = 3;
let inFlight = 0;
const waitQueue = [];

function pump() {
  while (inFlight < MAX_IN_FLIGHT && waitQueue.length) {
    const next = waitQueue.shift();
    next();
  }
}

export function gatedFetch(url, options) {
  return new Promise((resolve, reject) => {
    const start = () => {
      inFlight += 1;
      fetch(url, options)
        .then(resolve, reject)
        .finally(() => {
          inFlight -= 1;
          pump();
        });
    };
    if (inFlight < MAX_IN_FLIGHT) start();
    else waitQueue.push(start);
  });
}
